import { FC } from "react";
import { useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { bulkOperationsDrawerAF, RydeUiUnit } from "@ryde/shared";

import { MuiButton } from "../../../../controls";

interface IGenericExpand {
  entity: RydeUiUnit;
}

export const GenericExpand: FC<IGenericExpand> = ({ entity }) => {
  const setBulkOperationsDrawerState = useSetRecoilState(
    bulkOperationsDrawerAF(entity),
  );

  const handleOpenBulkOperationsDrawerClick = (): void => {
    setBulkOperationsDrawerState(true);
  };

  return (
    <MuiButton
      muiStyle="secondary"
      className="openDrawer"
      muiSize="small"
      onClick={handleOpenBulkOperationsDrawerClick}
    >
      <SVG_MUI.EllipsisVertical3SVG color="white" />
    </MuiButton>
  );
};
